import GiftCompliance from './GiftCompliance';

export default GiftCompliance;
